import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PyramidMark } from "@/components/Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) { navigate("/login"); return; }
    (async () => {
      try {
        const res = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        if (res.data.session_token) localStorage.setItem("yl_token", res.data.session_token);
        setUser(res.data.user);
        window.history.replaceState({}, "", "/");
        navigate("/", { replace: true });
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="h-screen grid place-items-center brand-gradient">
      <div className="flex flex-col items-center gap-4 text-white">
        <PyramidMark size={56} />
        <div className="text-sm animate-pulse">Signing you in securely…</div>
      </div>
    </div>
  );
}
